// import * as axios from 'axios';
// import appConfig from '../../config/app.conf'
import axios from "../../../plugins/axios";


function upload(formData,path) {
    const url = `https://staff.pgo.mv/api`+path;
    // return axios.post(url, formData).then(resp => resp)
    return axios.post( '/api' + path, formData).then(resp => resp)
}

export { upload }